import React from "react";
import { motion } from "framer-motion";
import { Block, BlockBetween, BlockHead, BlockHeadContent } from "../../../components/Component";
import UAGLogo from "../../../images/logo.png";

const AuthLoader = ({ loading_message }) => {
  return (
    <motion.div
      className="auth-loader-wrapper"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <Block size="lg" className="fade-in">
        <BlockBetween className="center">
          <BlockHead>
            <BlockHeadContent>
              {/* Logo */}
              <motion.div
                className="brand-logo"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <img className="logo" src={UAGLogo} alt="logo-dark" />
              </motion.div>

              {/* Loader Card */}
              <motion.div
                className="loader-card"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}
              >
                <div className="loader-content">
                  <motion.div
                    className="loader-text"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                  >
                    {loading_message || "Loading Page..."}
                  </motion.div>

                  {/* Spinner */}
                  <motion.div
                    className="spinner-container"
                    initial={{ rotate: 0 }}
                    animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 1.2, ease: "linear" }}
                  >
                    <div
                      className="spinner-border text-primary spinner"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            </BlockHeadContent>
          </BlockHead>
        </BlockBetween>
      </Block>

      <style jsx>{`
        .auth-loader-wrapper {
          width: 100%;
          max-width: 100%;
          height: auto;
          min-height: 30vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px;
          background: linear-gradient(135deg, #f8fafc, #edf2f7);
          border-radius: 12px;
          box-sizing: border-box;
        }

        .fade-in {
          width: 100%;
          max-width: 420px;
        }

        .brand-logo {
          margin-bottom: 1.5rem;
          display: flex;
          justify-content: center;
        }

        .logo {
          max-width: 140px;
          height: auto;
          object-fit: contain;
        }

        .loader-card {
          background-color: #fff;
          border-radius: 12px;
          padding: 1.5rem;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          text-align: center;
          width: 100%;
        }

        .loader-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .loader-text {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
          margin-bottom: 1rem;
        }

        .spinner-container {
          margin-top: 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .spinner {
          width: 2.5rem !important;
          height: 2.5rem !important;
          border-width: 0.25rem;
        }

        @media (max-width: 480px) {
          .fade-in {
            max-width: 100%;
          }
          .loader-card {
            padding: 1rem;
          }
          .loader-text {
            font-size: 16px;
          }
          .logo {
            max-width: 100px;
          }
        }
      `}</style>
    </motion.div>
  );
};

export default AuthLoader;
